import { combineReducers } from 'redux';
import { getCoreDataSecurityMonitorsByApplicationSlice } from './get';
import { removeCoreDataSecurityMonitorsByApplicationSyncSlice } from './remove';
import { updateCoreDataSecurityMonitorsByApplicationSyncSlice } from './update';

import { combineAllWatchers, joinReducers } from '@sonar-software/xuder';

export const coreDataSecurityMonitorsByApplicationReducers = combineReducers({
	get: joinReducers([
		getCoreDataSecurityMonitorsByApplicationSlice.asyncReducers,
		updateCoreDataSecurityMonitorsByApplicationSyncSlice.syncReducer,
		removeCoreDataSecurityMonitorsByApplicationSyncSlice.syncReducer
	], getCoreDataSecurityMonitorsByApplicationSlice.asyncState)
});

export const coreDataSecurityMonitorsByApplicationWatchers = combineAllWatchers([
	getCoreDataSecurityMonitorsByApplicationSlice.asyncWatchers
]);
